!(function (e) {
    function t(t) {
        for (var o, i, s = t[0], a = t[1], l = t[2], d = 0, m = []; d < s.length; d++) (i = s[d]), Object.prototype.hasOwnProperty.call(r, i) && r[i] && m.push(r[i][0]), (r[i] = 0);
        for (o in a) Object.prototype.hasOwnProperty.call(a, o) && (e[o] = a[o]);
        for (u && u(t); m.length; ) m.shift()();
        return c.push.apply(c, l || []), n();
    }
    function n() {
        for (var e, t = 0; t < c.length; t++) {
            for (var n = c[t], o = !0, s = 1; s < n.length; s++) {
                var a = n[s];
                0 !== r[a] && (o = !1);
            }
            o && (c.splice(t--, 1), (e = i((i.s = n[0]))));
        }
        return e;
    }



    var o = {},
        r = { 1: 0 },
        c = [];
    function i(t) {
        if (o[t]) return o[t].exports;
        var n = (o[t] = { i: t, l: !1, exports: {} });
        return e[t].call(n.exports, n, n.exports, i), (n.l = !0), n.exports;
    }
    (i.m = e),
        (i.c = o),
        (i.d = function (e, t, n) {
            i.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
        }),
        (i.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (i.t = function (e, t) {
            if ((1 & t && (e = i(e)), 8 & t)) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if ((i.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e))
                for (var o in e)
                    i.d(
                        n,
                        o,
                        function (t) {
                            return e[t];
                        }.bind(null, o)
                    );
            return n;
        }),
        (i.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return i.d(t, "a", t), t;
        }),
        (i.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (i.p = "");
    var s = (window.shopifySlateJsonp = window.shopifySlateJsonp || []),
        a = s.push.bind(s);
    (s.push = t), (s = s.slice());
    for (var l = 0; l < s.length; l++) t(s[l]);
    var u = a;
    c.push([60, 0]), n();
})({
    12: function (e, t, n) {},
    17: function (e, t, n) {},
    18: function (e, t, n) {},
    19: function (e, t, n) {},
    20: function (e, t, n) {},
    5: function (e, t, n) {
        "use strict";
        n.d(t, "a", function () {
            return o;
        }),
            n.d(t, "c", function () {
                return c;
            }),
            n.d(t, "d", function () {
                return i;
            }),
            n.d(t, "b", function () {
                return s;
            }),
            n(12);
        const o = ({ responseData: e }) => {
          		let freeReturn = `<!-- layout.theme.js --><div class="sidecart-message yu"> <div class="media"> <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M26.9715 17.724C30.1685 11.709 30.16 6.5605 28.6995 4.092C28.092 3.0655 27.2305 2.5 26.274 2.5C26.18 2.5 26.0845 2.5055 25.9905 2.517C24.422 2.705 23.813 4.486 22.969 6.9505C22.3715 8.696 21.6295 10.842 20.407 12.951C19.7285 12.0635 18.873 11.32 17.9515 10.882L17.9605 10.877C17.9315 10.8655 17.905 10.8575 17.876 10.8455C17.6286 10.7292 17.3714 10.6348 17.1075 10.5635C17.0185 10.541 16.9315 10.5235 16.8445 10.505C10.293 8.777 8.2155 17.138 11.7305 16.085C12.7545 15.778 13.446 14.1035 15.5345 12.4205C17.106 13.3745 18.14 15.073 17.781 16.314C16.5875 20.441 12.983 22.3175 8.857 22.3175C7.9275 22.3175 6.9715 22.2225 6.011 22.036C5.63593 21.9612 5.26495 21.8673 4.8995 21.7545C4.14828 21.5296 3.42069 21.2322 2.727 20.8665L1 22.342C1.42683 23.0138 1.90811 23.6495 2.439 24.2425C4.3595 26.395 6.9095 27.9455 9.8615 28.518C14.492 29.4155 19.0005 27.7075 22.0615 24.3725C23.7555 22.237 25.3855 21.347 26.7805 21.0785C26.5105 24.709 23.719 29.5 25.5965 29.5C25.668 29.5 25.747 29.4925 25.8325 29.4785C29.1585 28.923 31.1065 24.744 30.9955 22.096C30.877 19.2575 28.668 18.154 26.9715 17.724ZM20.587 18.1575C19.042 22.64 14.273 24.9165 9.413 24.9165C8.0515 24.9165 6.6735 24.708 5.335 24.311C5.013 24.1672 4.69707 24.0103 4.388 23.8405C4.6978 23.5397 4.99329 23.2245 5.2735 22.896C5.4635 22.944 5.644 22.984 5.821 23.018C6.847 23.2165 7.869 23.3175 8.8575 23.3175C11.294 23.3175 13.421 22.7105 15.103 21.5985C15.7135 21.814 16.575 21.682 17.3845 21.1735C18.5725 20.4275 19.1775 19.1765 18.7365 18.3785C18.6245 18.1765 18.45 18.032 18.2405 17.9295C18.436 17.504 18.6065 17.0605 18.7425 16.5915C19.0395 15.564 18.727 14.332 17.884 13.212C17.4652 12.6625 16.9631 12.1817 16.396 11.787C16.528 11.698 16.6665 11.61 16.8085 11.522C16.8254 11.5268 16.8426 11.5303 16.86 11.5325C18.271 11.6945 21.7085 14.903 20.587 18.1575ZM25.948 17.5255C23.2105 17.142 21.479 18.6085 21.479 18.6085C22.1355 16.8195 21.812 15.0905 21.024 13.879C24.0635 8.9145 24.328 3.7235 26.11 3.51C26.165 3.503 26.2195 3.5 26.274 3.5C28.6105 3.5 30.298 9.5555 25.948 17.5255ZM25.9695 28.4275C26.057 27.831 26.3875 26.7855 26.6435 25.9755C27.306 23.8785 28.195 21.066 27.6025 18.9625C28.7765 19.4395 29.922 20.3605 29.9965 22.1385C30.086 24.2815 28.533 27.7625 25.9695 28.4275Z" fill="#FF3D00"/> </svg> <div class="media-body"> <h5>Shop with confidence, *Exchanges are Free</h5></div></div></div><div class="ymal-carousel-wrapper"></div>`;
                const { items: t, item_count: n, total_price: o } = e;
                if(t.length == 0) {
                    freeReturn = '';
                }
                else {
                    var carousel = document.createElement("div");
                    fetch('/collections/best-sellers-1?view=ymal').then(function (response) {
                        // The API call was successful!
                        return response.text();
                    }).then(function (html) {
                        var parser = new DOMParser();
                        var doc = parser.parseFromString(html, 'text/html');
                        carousel.appendChild(doc.querySelector('.side-ymal'));
                        appendDiv(carousel);
                    }).catch(function (err) {
                        // There was an error
                        console.warn('Something went wrong.', err);
                    });
                }  
                    
                    window.checkcart = e;
                    
                    let current_value = e.total_price / 100,
                    progress_limit = window.gift_goals.limit,
                    current_progress = current_value / progress_limit * 100;
                    
                    var goal_template = ``;

                    var totalPrice_ = 0 ; 
                    let cont = 0;

                    for( let goal in gift_goals.goals){
                        
                        totalPrice_ = window.gift_goals.limit ;
                        let offset = window.gift_goals.goals[goal].value / window.gift_goals.limit * 100,
                        goal_classes;
                        if(current_value >= window.gift_goals.goals[goal].value){
                            goal_classes = '+ goal-marker goal-reached ';
            
                            if(window.gift_goals.goals[goal].variant != ''){
                    
                                let current_variants_in_cart = []; 
                                for(x in e.items){
                                    current_variants_in_cart.push(e.items[x].variant_id);
                                }
                    
                                if(!current_variants_in_cart.includes(parseFloat(window.gift_goals.goals[goal].variant))){
                                    ajaxAddToCart(window.gift_goals.goals[goal].variant);
                                }
                    
                            }
            
                        } else{
                            goal_classes = 'goal-marker';
                        }
                        
                        goal_template += `
                        <div class="${goal_classes}" style="left: calc(${offset}% - 16px);">
                            <span>${parseFloat(window.gift_goals.goals[goal].value) == 0 ? `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.88667 21.3335C9.71509 21.3335 10.3867 20.6619 10.3867 19.8335C10.3867 19.0051 9.71509 18.3335 8.88667 18.3335C8.05824 18.3335 7.38667 19.0051 7.38667 19.8335C7.38667 20.6619 8.05824 21.3335 8.88667 21.3335Z" fill="black"/>
                            <path d="M18 21.3335C18.8284 21.3335 19.5 20.6619 19.5 19.8335C19.5 19.0051 18.8284 18.3335 18 18.3335C17.1716 18.3335 16.5 19.0051 16.5 19.8335C16.5 20.6619 17.1716 21.3335 18 21.3335Z" fill="black"/>
                            <path d="M22.0533 3.57991C21.9913 3.50343 21.9131 3.44165 21.8243 3.399C21.7356 3.35635 21.6385 3.33389 21.54 3.33324H7.66L8.09333 4.66658H20.6667L18.8867 12.6666H8.88666L5.84 3.01991C5.80704 2.91755 5.74982 2.82468 5.6732 2.74922C5.59658 2.67377 5.50285 2.61796 5.4 2.58658L2.66666 1.74658C2.58262 1.72075 2.49431 1.71173 2.40678 1.72003C2.31924 1.72833 2.23421 1.7538 2.15651 1.79496C1.99961 1.8781 1.88216 2.02017 1.83 2.18991C1.77784 2.35965 1.79524 2.54316 1.87838 2.70006C1.96153 2.85697 2.10359 2.97442 2.27333 3.02658L4.66666 3.75991L7.72667 13.4266L6.63333 14.3199L6.54666 14.4066C6.27622 14.7182 6.12293 15.1145 6.1132 15.527C6.10346 15.9395 6.23789 16.3425 6.49333 16.6666C6.67504 16.8875 6.90594 17.0629 7.16756 17.1787C7.42918 17.2945 7.71426 17.3474 8 17.3332H19.1267C19.3035 17.3332 19.473 17.263 19.5981 17.138C19.7231 17.013 19.7933 16.8434 19.7933 16.6666C19.7933 16.4898 19.7231 16.3202 19.5981 16.1952C19.473 16.0701 19.3035 15.9999 19.1267 15.9999H7.89333C7.81656 15.9973 7.74177 15.9749 7.67617 15.9349C7.61057 15.895 7.55639 15.8388 7.51886 15.7717C7.48133 15.7047 7.46172 15.6292 7.46192 15.5523C7.46211 15.4755 7.48212 15.4001 7.52 15.3332L9.12666 13.9999H19.42C19.5741 14.0037 19.7248 13.9539 19.8463 13.8591C19.9679 13.7643 20.0528 13.6303 20.0867 13.4799L22.2 4.14658C22.2203 4.04719 22.2176 3.94448 22.1922 3.84629C22.1668 3.74809 22.1193 3.65698 22.0533 3.57991Z" fill="black"/>
                            </svg>
                            `: `$`+window.gift_goals.goals[goal].value}</span>
                            <span>${goal}</span>
                        </div>
                        `;
                        cont += 1;
                        
                    }

     const afterpayScript = document.createElement('script');
    afterpayScript.src = 'https://js.afterpay.com/afterpay-1.x.js';
    afterpayScript.setAttribute('data-min', '1.00');
    afterpayScript.setAttribute('data-max', '2000.00');
    afterpayScript.async = true;
          document.head.appendChild(afterpayScript);
   
    let targetSelector = "";
    let attributes = {};
    attributes.size = "xs"; // xs, sm, md, lg
    attributes.showUpperLimit = true;
    attributes.showLowerLimit = false;
    attributes.logoType = "lockup";
    attributes.isEligible = true;
    attributes.locale = "en_US";
    attributes.currency = "USD";
attributes.amount = `${o / 100}`;

    targetSelector = '.product-priceafternew';
            
    attributes.amountSelector = "product-priceafternew";
   
    Afterpay.createPlacements({
        targetSelector,
        attributes
    });
          
             $('.affirm-as-low-as').attr('data-amount', attributes.amount);
setTimeout(() => {
    let _shopify_locale = Shopify.locale;
    let _shopify_country = Shopify.country;
    let _affirm_locale;
    let _affirm_country;

    if (_shopify_country === 'US') {
        _affirm_country = 'USA';
        _affirm_locale = 'en_US';
    } else if (_shopify_country === 'CA') {
        _affirm_country = 'CAN';
        _affirm_locale = (_shopify_locale === 'fr' ? 'fr' : 'en') + '_' + _shopify_country;
    } else {
        _affirm_country = 'USA';
        _affirm_locale = 'en_US';
    }

    _affirm_config = {
        public_api_key: "{_region_public_key}",
        script: "https://cdn1.affirm.com/js/v2/affirm.js",
        locale: _affirm_locale,
        country_code: _affirm_country,
    };

    (function (l, g, m, e, a, f, b) {
        var d, c = l[m] || {}, h = document.createElement(f),
            n = document.getElementsByTagName(f)[0],
            k = function (a, b, c) {
                return function () {
                    a[b]._.push([c, arguments])
                }
            };
        c[e] = k(c, e, "set");
        d = c[e];
        c[a] = {};
        c[a]._ = [];
        d._ = [];
        c[a][b] = k(c, a, b);
        a = 0;
        for (b = "set add save post open empty reset on off trigger ready setProduct".split(" "); a < b.length; a++)
            d[b[a]] = k(c, e, b[a]);
        a = 0;
        for (b = ["get", "token", "url", "items"]; a < b.length; a++)
            d[b[a]] = function () {
            };
        h.async = !0;
        h.src = g[f];
        n.parentNode.insertBefore(h, n);
        delete g[f];
        d(g);
        l[m] = c
    })(window, _affirm_config, "affirm", "checkout", "ui", "script", "ready");
    affirm.ui.refresh();
});


                    // var missingValue = totalPrice_ - current_value ;
                    // var renderMissingValue = current_progress < 100 ? 
                    // (   'You are' + " " + "$" +  " " + missingValue + " " + 'away from getting free 2-day shipping' ) : 
                    // (   'Made It! Enjoy Your Free 2-Day Shipping' );

                    {/* <div class="container-goals-missingValue">${renderMissingValue} </div> */}


          
$.get("https://ipinfo.io", function(response) {

  var country = response.country;
  var state = response.region;
  var shipping_value = 150; // Assuming $150 is the shipping value
  var totalPrice_ = o / 100;
  var currentcurrency = window.currentcountry;
  
//console.log(currentcurrency);

var totalPrice_new = window.checkcart.original_total_price / 100;
var shipping_value_left = shipping_value - totalPrice_new;

let custom__percentage_left = (totalPrice_new / shipping_value) * 100;
  
console.log(custom__percentage_left + "% left to reach the shipping goal");

var excludedStates = ['HI', 'PR', 'GU'];
    var freeShippingNotice = '';

    if (currentcurrency === 'United States' && !excludedStates.includes(state)) {
        if (totalPrice_new >= shipping_value) {
          
            freeShippingNotice = `<div class="shipping-savings-message">
                <img style="display: none;" class="free_shipping_notice" src="https://cdn.shopify.com/s/files/1/0014/4297/1709/files/truck-icon.png?v=1715320796">
                <div class="progress-container" bis_skin_checked="1">
                  <div class="progress-bar" id="progressBar" bis_skin_checked="1" style="width: 100%"></div>
                </div>
                <span class="free_shipping_notice"><b>CONGRATS! YOU GET FREE GROUND SHIPPING!</b></span>
            </div>`;
        } else {
          
            freeShippingNotice = `<div class="shipping-savings-message">
                <img style="display: none;" class="free_shipping_notice" src="https://cdn.shopify.com/s/files/1/0014/4297/1709/files/truck-icon.png?v=1715320796">
                <div class="progress-container" bis_skin_checked="1">
                  <div class="progress-bar" id="progressBar" bis_skin_checked="1" style="width: ${custom__percentage_left}%"></div>
                </div>
                <span class="free_shipping_notice">YOU ARE <b>$${shipping_value_left.toFixed(2)}</b> AWAY FROM <b>FREE GROUND SHIPPING!</b></span>
            </div>`;
        }
    } else {
        console.log("Free shipping offer not available for your location.");
    }

    // Define FitRec HTML snippet

    const userId = Shopify.customer && Shopify.customer.id ? Shopify.customer.id : 'guest';
    const locale = Shopify.locale + '_' + Shopify.country;

    const fitRecDiv = `<div class="tfc-fitrec-size-sampling" 
                      data-userid="${userId}" 
                      data-locale="${locale}">
                   </div>`;


    // Insert the notice into the placeholder, including the FitRec snippet
    if (freeShippingNotice) {
      document.getElementById('shipping-notice').innerHTML = freeShippingNotice + fitRecDiv;
    }
  }, "jsonp");
                    let sideCartGoals = `<div class="container-goals"><div class="sidecart__goals-header"><div class="container-goals-missingValue"></div></div> <div class="sidecart__goals"><div class="sidecart__goals--progress" style="width:${current_progress}%;"></div>${goal_template}</div></div>`

                    return `
    <div class="test mini-cart-inner">
        <div class="cart-header">
            <span class="desktop caps">
                Shopping Cart: <span id="sp-cart-count">${n}</span>
            </span>
            <button class="close">×</button>
        </div>
        ${window.gift_goals ? sideCartGoals : ""}
        <div id="shipping-notice"></div>
        <div class="mini-cart-items caps">
            ${t.map((e, t) => r({ ...e, i: t })).join("")}
            ${freeReturn}
        </div>
        <div class="mini-cart-bottom">
            <div class="mini-cart-total">
                Subtotal: ${Shopify.currency.active} <span id="sp-cart-subtotal">${(
                    o / 100
                ).toFixed(2)}</span>
            </div>
            <div class="mini-cart-message">
                Free Domestic Shipping & Returns
            </div>
        </div>
        <a class="checkout gfghfgh yuyuyu" href="/checkout">
            SECURED CHECKOUT
        </a>
    </div>
`;

            },
            r = ({ product_title: e, url: a, variant_title: t, quantity: n, price: o, image: r, discounts: d, i: c }) => {
    const currencyCode = Shopify.currency.active; // Fetch active currency code dynamically

    var sourceURL = a;

    var vararray = sourceURL.split("?")[1];
    var varId = vararray.split("=")[1];
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === "variant") {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }

    var isFinalsale = false;
    var isPresale = false;

    $.ajax({
        url: rtn + ".js",
        async: false,
        dataType: "json",
        success: function (product) {
            if (product.tags.indexOf("final-sale") > -1) {
                isFinalsale = true;
            }
            if (product.tags.indexOf("preorder") > -1) {
                isPresale = true;
            }
        },
    });

    return `
        <div class="cart-item">
            <div class="cart-item-info">
                <div class="cart-item-properties">
                    <h3 class="title">
                        <a href="${a}">${e}</a>
                    </h3>
                    <button class="remove yu" data-line-item="${+c + 1}">x</button>
                    <p class="variant-title">${t}</p>
                    ${isFinalsale ? '<p class="final-sale-cart">Final-sale</p>' : ''}
                    ${isPresale ? '<p class="pre-order-cart">Pre-order</p>' : ''}
                    <p class="price">
                        ${currencyCode} ${(
                            o / 100
                        ).toFixed(2)}
                        ${
                            d.length > 0
                                ? `<span class="cart-item-discounts">${d[0].title} (-${currencyCode} ${(
                                      d[0].amount / 100
                                  ).toFixed(2)})</span>`
                                : ""
                        }
                    </p>
                </div>
            </div>
            <div class="cart-item-image">
                <a href="${a}">${r ? `<img src="${r}"/>` : ""}</a>
            </div>
        </div>
    `;
};


var selectCallback = function(cart) {
    // Check if the 'cart' object is defined and contains a 'total_price' property
    if (cart && cart.total_price) {
        // Update the data-amount attribute of elements with the class 'affirm-as-low-as'
        $('.affirm-as-low-as').attr('data-amount', cart.total_price);

        // Select the <p> element under the 'affirm-as-low-as' class
        var paragraphElement = $('.affirm-as-low-as p');
alert(paragraphElement);
        // Update the text content of the <p> element
        paragraphElement.text('New text here: $' + cart.total_price);
    } else {
        console.log("Cart object or total_price is not defined. Ensure that the cart is properly updated.");
    }
};

          function c() {
          console.log('here1');
            return window
                .fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json", "Content-Type": "application/json" } })
                .then((e) => e.json())
                .catch((e) => {
                    throw new Error(e);
                });
            
        }
      	function removeParam(key, sourceURL) {
            var rtn = sourceURL.split("?")[0],
            param,
            params_arr = [],
            queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
            if (queryString !== "") {
            params_arr = queryString.split("&");
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split("=")[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
            }
            return rtn;
}

        function getProductTagFromApi(product) {
            product=removeParam("variant", product);
            jQuery.getJSON('/products/'+product+'.js', function(product) {
             return product.tags;
            } );
        }
        function i({ id: e, quantity: t, properties: n }) {
            const o = JSON.stringify({ id: e, quantity: t, properties: n });
            return window
                .fetch("/cart/add.js", { headers: { "Content-Type": "application/json" }, credentials: "same-origin", method: "POST", body: o })
                .then((e) => e.json())
                .catch((e) => {
                    throw new Error(e);
                });
        }
        function s({ line: e }) {
            return (function ({ line: e, quantity: t }) {
                const n = JSON.stringify({ line: e, quantity: t });
                return window
                    .fetch("/cart/change.js", { headers: { "Content-Type": "application/json" }, credentials: "same-origin", method: "POST", body: n })
                    .then((e) => e.json())
                    .catch((e) => {
                        throw new Error(e);
                    });
            })({ line: e, quantity: 0 });
        }
        function appendDiv (div){
          document.querySelector('.ymal-carousel-wrapper').appendChild(div);
          var elem = document.querySelector('.ymal-carousel');
          var flkty = new Flickity( elem, {
            // options
           cellAlign: 'left',
            contain: true
          });
        }
    },
    60: function (e, t, n) {
        "use strict";
        n.r(t), n(17), n(18);
        var o = n(5);
        function r(e) {
            e.forEach((e) => {
                const { target: t, isIntersecting: n } = e;
                switch (t.tagName) {
                    case "IMG":
                        n && ((t.src = t.dataset.src), t.hasAttribute("data-srcset") && (t.srcset = t.dataset.srcset), t.removeAttribute("defer"));
                        break;
                    case "VIDEO":
                        n ? ((t.currentTime = 0), t.play(), t.removeAttribute("defer")) : t.pause();
                        break;
                    default:
                        n && t.removeAttribute("defer");
                }
            });
        }
        document.addEventListener("DOMContentLoaded", () => {
        //    document.querySelector("#menu-button").addEventListener("click", (e) => {
          //   //   document.querySelector(".mobile.nav-container").classList.toggle("mobile-nav--open"),
                //    scrollTo(0, 0),
                //    document.querySelector("button.category") && (document.querySelector("button.category").classList.remove("expanded"), document.querySelector("ul.sticky").classList.remove("expanded"));
           // }),
                document.querySelector(".mobile.nav-container").addEventListener("click", (e) => {
                    document.querySelector(".mobile.nav-container").classList.toggle("mobile-nav--open");
                }),
                document.querySelectorAll(".mini-cart-link").forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault(),
                            document.querySelector("#shopify-section-mini-cart").classList.add("open"),
                          jQuery("html").addClass("freez-page");
                            Object(o.c)().then((e) => {
                                document.querySelector("#mini-cart-container").innerHTML = Object(o.a)({ responseData: e });
                                tfSizeSampling();
                            });
                    });
                }),
                document.querySelector("#mini-cart-container").addEventListener("click", (e) => {
                    if ((e.target.classList.contains("close") && (e.preventDefault(), document.querySelector("#shopify-section-mini-cart").classList.remove("open")), e.target.classList.contains("remove"))) {
                        const t = +e.target.dataset.lineItem;
                        Object(o.b)({ line: t }).then((e) => {
                          document.querySelector("#mini-cart-container").innerHTML = Object(o.a)({ responseData: e });
                          console.log("responseData.item_count", e.item_count);
                          document.querySelector(".mini-cart-link .count").innerHTML = e.item_count;
                          if (e.item_count == 0) {
                              document.querySelector("#shopify-section-mini-cart").classList.remove("open");
                          }
                          tfSizeSampling(); // Add this line here to update True Fit after item removal
                      });

                    }
                }),
                document.querySelector("#shopify-section-mini-cart").addEventListener("click", (e) => {
                    e.target.classList.contains("open") && document.querySelector("#shopify-section-mini-cart.open").classList.remove("open");
                jQuery("html").removeClass("freez-page");});
        }),
            n(19),
            document.addEventListener("DOMContentLoaded", () => {
                const e = document.querySelector("footer a.instagram-link");
                e && e.setAttribute("target", "_blank");
            }),
            n(20),
            n(7),
            document.addEventListener("DOMContentLoaded", () => {
                document.querySelector("#shopify-section-newsletter").addEventListener("click", (e) => {
                    e.target.classList.contains("shopify-section") && document.querySelector("#shopify-section-newsletter").classList.remove("open"),
                        e.target.classList.contains("close") && document.querySelector("#shopify-section-newsletter").classList.remove("open"),
                        console.log("mc clicked");
                });
            }),
            window.addEventListener("load", (e) => {
                document.documentElement.classList.remove("loading");
            }),
            window.addEventListener("scroll", function () {
                var e = window.pageYOffset || document.documentElement.scrollTop;
                requestAnimationFrame(() => {
                    document.documentElement.classList.toggle("scrolled", e > 0);
                });
            }),
            document.addEventListener("DOMContentLoaded", () => {
                if ("function" == typeof IntersectionObserver) {
                    const e = new IntersectionObserver(r, { rootMargin: "0% 0% 0% 0%" });
                    document.querySelectorAll("[defer]").forEach((t) => {
                        e.observe(t);
                    });
                } else
                    document.querySelectorAll("img[defer]").forEach((e) => {
                        (e.src = e.dataset.src), e.removeAttribute("defer");
                    }),
                        document.querySelectorAll("video[defer]").forEach((e) => {
                            (e.controls = !0), e.removeAttribute("defer");
                        }),
                        document.querySelectorAll("[defer]:not(img):not(video)").forEach((e) => {
                            e.removeAttribute("defer");
                        });
            });
    },
});

$('.variants select').change(function(){
  console.log("pppppp") ; 
  $('.variants select ').val($(this).val());
});

$('body').on('click',  '.container-atc .variant-selector', function(e){
  e.preventDefault();
  alert("ok");
  let variant_id = $(this).attr('data-variant-id');
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      "id": variant_id,
      "quantity": 1
    },
    dataType: 'json',
    success: function(data){ 
    	document.querySelector(".mini-cart-link").click()
    }
  })

})


$('body').on('click', '.container-atc .btn-add-to-cart', function(){
  $('.container-atc .btn-add-to-cart').removeClass('active');
  $(this).addClass('active');
})

$(document).on('click', function(e) {
     if ($(e.target).parents('#container-atc').length == 0 ){
         $('.container-atc .btn-add-to-cart').removeClass('active')                        
     }
});

$('body').on('click', '.product-grid__wrapper .info.with-color-swatches .product-other-colorways .colorway',  function(e){
  $(this).closest('.product-other-colorways').find('.colorway').removeClass('selected');
  $(this).addClass('selected');
  e.preventDefault();
  let $this = $(this);
  $.ajax({
    'async': false,
    'type': "GET",
    'global': false,
    'dataType': 'JSON',
    'url': '/products/'+ $this.attr('data-product-handle') +'.json',
    'success': function (data) {
      
      let $parent = $this.closest('.product-grid__wrapper'),
          old_url = $this.closest('.product-grid__wrapper').find('a').first().attr('href'),
          new_url = old_url.substring(0, (old_url.indexOf('/products/') + 10));
      
      $parent.find('a').attr('href', new_url+data.product.handle );
      $parent.find('.title').text(data.product.title);
      $parent.find('img.first').attr('src',data.product.images[0].src);
      $parent.find('img.second').attr('src',data.product.images[1].src);
      $parent.find('img').attr('alt', data.product.title);

      if(data.product.variants.length > 1) {
        $parent.find('.variants').empty();

        let prod_ = false;
        for (let name in window.coll_prods ) {
            if(coll_prods[name].id == data.product.id){
                prod_ = coll_prods[name];
                break;
            }
        }


        $.each(data.product.variants, function(index, element){
          let position = false;
          data.product.options.forEach(function(option, index){
            if(option.name.toLowerCase() == "size"){
              position = option.position;
            }
          })

          let new_element;
          
          switch(position) {
            case 1:
              new_element = `<a class="variant-selector ${prod_.variants[index].available ? '':'unavailable' }" href="${new_url+data.product.handle}" data-variant-id="${element.id}">${element.option1}</a>`;
              break;
            case 2:
              new_element = `<a class="variant-selector ${prod_.variants[index].available ? '':'unavailable' }" href="${new_url+data.product.handle}" data-variant-id="${element.id}">${element.option2}</a>`;
              break;
            case 3:
              new_element = `<a class="variant-selector ${prod_.variants[index].available ? '':'unavailable' }" href="${new_url+data.product.handle}" data-variant-id="${element.id}">${element.option3}</a>`;
              break;
          }
          
          $parent.find('.variants').append(new_element)
        })
      } else { 
        $parent.find('.variant-selector').attr('data-variant-id', data.product.variants[0].id)
      }

      $parent.find('.container-atc .variant-selector').on('click', function(e){
        e.preventDefault();
        let variant_id = $(this).attr('data-variant-id');
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            "id": variant_id,
            "quantity": 1
          },
          dataType: 'json',
          success: function(data){ 
            document.querySelector(".mini-cart-link").click()
          }
        })
      })
      
        // $('.variant-selector.unavailable').each(function(){
        //     let $element = $(this);
        //     $('.variant-selector').each(function(){
        //         if($(this).attr('data-variant-id') == $element.attr('data-variant-id') ){
        //             $(this).addClass('unavailable')
        //         }
        //     })
        // })

      if(data.product.tags.indexOf("BFCM2021") > -1) { $parent.find('.coin-bfcm').removeClass('hidden') }else{ $parent.find('.coin-bfcm').addClass('hidden')}
    }
  });
})

const activateVariants = (e) => {
    e.preventDefault();
    e.target.nextElementSibling.classList.add('active');
}

let removeActiveClassYMAL_ATC = () => {
    let container_variants = document.querySelectorAll('.variants'), container_variants_active = document.querySelectorAll('.variants.active') ;
    if(container_variants_active.length > 1){
        container_variants.forEach((element) => {
            element.classList.remove('active');
        })
    }
}

document.addEventListener('click', (e)=>{
    e.target.closest('.variants') ? console.log('') : removeActiveClassYMAL_ATC();
})

const addToCart = async (id) => {
    const o = JSON.stringify({
        id: id,
        quantity: 1
    });
  	let target_ = window.event.target.closest('.side-ymal');
    
    try {
        const e = await window
            .fetch("/cart/add.js", {
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "same-origin",
                method: "POST",
                body: o
            });
    	document.querySelector(".mini-cart-link").click()
        if(target_){
            ga('send', 'event', 'button', 'click', 'upsellaction');
        }
        return await e.json();
    } catch (e_1) {
        throw new Error(e_1);
    }
    
}

const initialize_color_swatches = ()=>{
    // console.log('initializing color swatches');
    let products_other_colorways = document.querySelectorAll('[data-product-other-colorways-id]');
    

    products_other_colorways.forEach(element => {
      if (element.children.length == 0 || document.querySelector('body').classList.contains('template-product')){
      	let thisBaseProduct = element.getAttribute('data-product-other-colorways-base-product').toLowerCase(),
            product_id = element.getAttribute('data-product-other-colorways-id'),
            template=``;
        
        for (let name in window.coll_prods ) {
            let baseProduct = coll_prods[name].title.toLowerCase().replaceAll(' ', '-').split('-in-')[0],
            colorway = coll_prods[name].title.toLowerCase().replaceAll(' ', '-').split('-in-');
            colorway = colorway[colorway.length - 1];
      let formattedColorway = colorway.split('/').join('-');

        	if(baseProduct == thisBaseProduct){
              template += `<a data-product-handle="${coll_prods[name].handle}" title="${coll_prods[name].title}" class="colorway color--${formattedColorway} ${ product_id == coll_prods[name].id ? 'selected':'' } " href="${window.location.href.split('products/')[0] + 'products/' + coll_prods[name].handle}"></a>`
            }
        }
        element.innerHTML += template;
      }
    })
}

document.addEventListener("DOMContentLoaded", function() {
    initialize_color_swatches();
});